import { makeAutoObservable } from 'mobx'
import type { IActionsProps } from 'shared/ui'
import { type IResponseCustomPlan } from 'entities/Admin/customPrices/api/type'

export class BillingCustomPlan {
  id: IResponseCustomPlan['id']
  label: IResponseCustomPlan['label']
  name: IResponseCustomPlan['name']
  interval: IResponseCustomPlan['interval']
  contract_term: IResponseCustomPlan['contract_term']
  credits: IResponseCustomPlan['interval_credits']
  seats: IResponseCustomPlan['seats']
  numbers: IResponseCustomPlan['numbers']
  percent: IResponseCustomPlan['percent']
  type: IResponseCustomPlan['type']
  status: IResponseCustomPlan['status']
  is_enterprise_trial_available: IResponseCustomPlan['is_enterprise_trial_available']
  usage: IResponseCustomPlan['usage']
  actionsProps: IActionsProps | null = null

  private _stripe_id: IResponseCustomPlan['stripe_id'] = ''
  private _price = 0
  private _additional_credit_price = 0
  private _credit_price = 0

  origin: IResponseCustomPlan

  constructor(item: IResponseCustomPlan) {
    this.id = item.id
    this.label = item.label
    this.name = item.name
    this.interval = item.interval

    this.contract_term = item.contract_term
    this.credits = Number(item.interval_credits)
    this.seats = item.seats
    this.numbers = item.numbers
    this._stripe_id = item.stripe_id
    this.percent = item.percent ? Number(item.percent) : null
    this.type = item.type
    this.status = item.status
    this.is_enterprise_trial_available = item.is_enterprise_trial_available
    this.usage = item.usage

    this._price = item.price
    this._additional_credit_price = Number(item.additional_credit_price)
    this._credit_price = Number(item.credit_price)

    this.origin = item

    makeAutoObservable(this)
  }

  get stripe_id() {
    if (this._stripe_id) return this._stripe_id

    return String(this.id)
  }

  get additional_credit_price() {
    return this._additional_credit_price
  }

  get credit_price() {
    return this._credit_price
  }

  get price_cents() {
    return this._price
  }

  get price_dollars() {
    return this._price / 100
  }

  get price_add() {
    const priceAdd =
      Math.round(Math.abs(this.credits * this.credit_price - this.price_dollars) * 100) / 100

    if (this.credits * this.credit_price > this.price_dollars) {
      return -priceAdd
    }

    return priceAdd
  }

  setActionsProps = (actionProps: IActionsProps) => {
    this.actionsProps = actionProps
  }
}
